<template>
  <svg ref="barcode"></svg>
</template>

<script>
  import JsBarcode from "jsbarcode"

  export default {
    name: "Barcode128",
    props: {
      value: {
        type: String,
        required: true
      },
      displayValue: {
        type: Boolean,
        default: true
      }
    },
    mounted() {
      this.renderBarcode()
    },
    watch: {
      value() {
        this.renderBarcode()
      }
    },
    methods: {
      renderBarcode() {
        JsBarcode(this.$refs.barcode, this.value, {
          format: "CODE128",
          height: 48,
          width: 1.5,
          fontSize: 14,
          textMargin: 4,
          margin: 0,
          displayValue: this.displayValue
        })
      }
    }
  }
</script>
